import React, { FunctionComponent as F, useEffect, useRef, useState } from "react";
import Stack from "@mui/material/Stack";
import { Grid, TextField } from "@mui/material";
import { useAppDispatch } from "../../core/store/hooks";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '../UI/Button/Button';
import { validateProtocolOrFolderName } from "../../utils/validate";
import Timeout from "await-timeout";
import { useSelector } from "react-redux";
import { IState } from "../../core/store/store";
import { createFolderAsync } from "../../core/store/protocol/protocolFolder.thunks";



interface IProps
{
  parentFolderId?: number,
  close: () => void,
  open: boolean
}

const NewFolderDialog: F<IProps> = (props: IProps) =>
{
  const appDispatch = useAppDispatch();
  const parentFolderName = useSelector((state: IState) => state.protocol.folders
    .find(f => f.folderId === props.parentFolderId)?.name);

  const [name, setName] = useState("");

  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() =>
  {
    if(!props.open)
      return;

    (new Timeout()).set(0).then(() => inputRef?.current?.select());
  }, [props.open]);

  const handleDone = async() =>
  {
    if(!name)
      return;

    await appDispatch(createFolderAsync(name, props.parentFolderId));
    setName("");
    props.close();
  }

  const handleCancel = async() =>
  {
    props.close();
    setName("");
  }

  function handleKeyPress(event: React.KeyboardEvent<HTMLDivElement>)
  {
    event.key === 'Enter' && handleDone();
  }

  return (
    <Dialog
      maxWidth='md'
      PaperProps={{ sx: { p: '15px', textAlign: 'center' }}}
      open={props.open}
      onClose={handleCancel}>
      <DialogTitle sx={{ fontSize: '30px' }}>{"Create new folder in '" + parentFolderName + "'"}</DialogTitle>
      <DialogContent>

        <Stack spacing={2}>

          <Grid container direction='row'>
            <Grid item xs key={0} style={{ display: "flex", justifyContent: "flex-start" }}>
              <TextField
                InputProps={{ inputRef }}
                variant='standard'
                sx={{ color: validateProtocolOrFolderName(name) ? 'black' : 'red' }}
                inputProps={{ style: { fontSize: 14 } }}
                fullWidth
                size='small'
                value={name}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setName(event.target.value)}
                onKeyPress={handleKeyPress}
                error={!validateProtocolOrFolderName(name)}/>
            </Grid>
          </Grid>

          <Grid container direction='row' key={2}>
            <Grid item xs style={{ display: "flex", justifyContent: "center" }}>
              <Button
                label='Ok'
                onClick={handleDone}/>
              <Button
                label='Cancel'
                onClick={handleCancel}/>
            </Grid>
          </Grid>

        </Stack>
      </DialogContent>
    </Dialog>);
}

export default NewFolderDialog;

